export default __webpack_public_path__ + "9aac7036d9271109ff142dc92ef38242.svg";